import { requestVip as request } from '../../request';


export const getShareConfig = (url) => {
  return request({
    url: '/wap/we_chat/share_config',
    method: 'post',
    data: {
      platform: 'm',
      url
    }
  });
};

/**
 * 行业锦囊列表 
 */
export const xhrIndustryStrategyList = (cookie) => {
  const params = {
    url: '/wap/IndustryStrategy/list',
    method: 'POST'
  }
  if(cookie) {
    params.headers = {
      'Cookie': cookie
    }
  }
  return request(params);
}

/**
 * 行业锦囊详情
 */
export const xhrIndustryStrategyDetail = (cookie, id) => {
  const params = {
    url: '/wap/IndustryStrategy/detail',
    method: 'POST',
    data: {
      id
    }
  }
  if(cookie) {
    params.headers = {
      'Cookie': cookie
    }
  }
  return request(params);
}
/**
 * 行业锦囊 关联公司
 */
export const xhrIndustryStrategyCompanyList = (cookie, params) => {
  const config = {
    url: '/wap/IndustryStrategy/companyList',
    method: 'POST',
    data: params
  };
  if(cookie){
    config.headers = {
      'Cookie': cookie
    }
  }
  return request(config);
}

export const dynamicDetail = (cookie, id) => {
  const config = {
    url: '/v1/industrialCircle/dynamicDetail',
    method: 'POST',
    data: {
      dynamic_id: id,
      is_show: 1, // 审核页面获取数据的时候需要传
    }
  };
  if(cookie){
    config.headers = {
      'Cookie': cookie
    }
  }
  return request(config);
}

export const approve = (params) => {
  return request({
    url: '/inner/IndustrialCircle/check',
    method: 'POST',
    data: {
      platform: 'm',
      ...params
    }
  });
}